// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-form-container {
  width: 100vw;
  height: 100vh;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  margin-top: 10rem;
  display: flex;
  justify-content: center;
}

.account-form-card-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  border-radius: 16px;
  border: 2px solid #5a67d8;
  background-color: #edf2f7;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.account-form-avatar img {
  margin-top: 2rem;
  width: 3.5rem;
  height: auto;
  border: 2px solid #5a67d8;
  padding: 1rem 1.5rem;
  border-radius: 50%;
}

.account-form {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  gap: 1rem;
}

.account-form .label-text {
  display: flex;
  flex-direction: column;
  justify-content: left;
  text-align: left;
}

.btn-save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1rem;
  background-color: #4ae33c;
  font-size: 1.25rem;
  font-weight: 700;
  border-radius: 0.5rem;
  border: 1px solid #334155;
  padding: 8px 16px;
  color: black;
  cursor: pointer;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  min-height: 3rem;
  line-height: 1;
  border-color: transparent;
  outline-color: transparent;
}

.logout-btn {
  position: relative;
  bottom: 0;
  left: 0;
  padding: 8px 16px;
  background-color: #ff4d4f;
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.form-control {
  width: 100%;
  max-width: 80vw;
  gap: 1rem;
  font-size: 1.25rem;
  border-radius: 4px;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
}

/* .form-control .input {
  width: ;
}

.form-control .image-input {
  width: ;
} */

.edit-account-instructions {
  color: #247a97;
  font-size: 2rem;
  font-weight: 900;
  margin-top: 5rem;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

@media screen and (max-width: 991px) {
  .account-form-card-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80vw;
    height: 80vh;
    align-items: center;
    padding: 0.75rem;
    border-radius: 16px;
    border: 2px solid #5a67d8;
    background-color: #edf2f7;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .account-form-card-container .card-body {
    margin-top: 5vh;
  }

  .welcome-user-text {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  .edit-account-instructions {
    font-size: 1.5rem;
    margin: 0;
  }
  .account-form-avatar img {
    margin: 1rem;
  }

  .form-control {
    width: 50vw;
    margin: 0;
  }

  .form-control .image-input {
    width: 30vw;
    font-size: 1rem;
    margin-top: 0.5rem;
  }

  .form-control {
    width: 35vw;
    margin: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AccountForm.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,qBAAqB;EACrB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;GAMG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF","sourcesContent":[".account-form-container {\n  width: 100vw;\n  height: 100vh;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 1rem;\n  margin-top: 10rem;\n  display: flex;\n  justify-content: center;\n}\n\n.account-form-card-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0.75rem;\n  border-radius: 16px;\n  border: 2px solid #5a67d8;\n  background-color: #edf2f7;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.account-form-avatar img {\n  margin-top: 2rem;\n  width: 3.5rem;\n  height: auto;\n  border: 2px solid #5a67d8;\n  padding: 1rem 1.5rem;\n  border-radius: 50%;\n}\n\n.account-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n  align-items: left;\n  gap: 1rem;\n}\n\n.account-form .label-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n  text-align: left;\n}\n\n.btn-save {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 1rem;\n  background-color: #4ae33c;\n  font-size: 1.25rem;\n  font-weight: 700;\n  border-radius: 0.5rem;\n  border: 1px solid #334155;\n  padding: 8px 16px;\n  color: black;\n  cursor: pointer;\n  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  user-select: none;\n  min-height: 3rem;\n  line-height: 1;\n  border-color: transparent;\n  outline-color: transparent;\n}\n\n.logout-btn {\n  position: relative;\n  bottom: 0;\n  left: 0;\n  padding: 8px 16px;\n  background-color: #ff4d4f;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.form-control {\n  width: 100%;\n  max-width: 80vw;\n  gap: 1rem;\n  font-size: 1.25rem;\n  border-radius: 4px;\n  margin-top: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n/* .form-control .input {\n  width: ;\n}\n\n.form-control .image-input {\n  width: ;\n} */\n\n.edit-account-instructions {\n  color: #247a97;\n  font-size: 2rem;\n  font-weight: 900;\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n@media screen and (max-width: 991px) {\n  .account-form-card-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 80vw;\n    height: 80vh;\n    align-items: center;\n    padding: 0.75rem;\n    border-radius: 16px;\n    border: 2px solid #5a67d8;\n    background-color: #edf2f7;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .account-form-card-container .card-body {\n    margin-top: 5vh;\n  }\n\n  .welcome-user-text {\n    font-size: 3rem;\n    margin-bottom: 1rem;\n  }\n\n  .edit-account-instructions {\n    font-size: 1.5rem;\n    margin: 0;\n  }\n  .account-form-avatar img {\n    margin: 1rem;\n  }\n\n  .form-control {\n    width: 50vw;\n    margin: 0;\n  }\n\n  .form-control .image-input {\n    width: 30vw;\n    font-size: 1rem;\n    margin-top: 0.5rem;\n  }\n\n  .form-control {\n    width: 35vw;\n    margin: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
